import { lazy } from "react"

/**
 * lazyPage - React.lazy for route pages (Stage 2.3 code splitting).
 *
 * A failed chunk request (e.g. a dropped connection) is retried once before the error reaches the
 * route ErrorBoundary; webpack allows a failed chunk to be requested again.
 *
 * Create one lazyPage per page module (not per route) so routes that share a page keep sharing
 * the same component type, exactly as with a static import.
 */
export default function lazyPage(importPage) {
  return lazy(() => importPage().catch(() => importPage()))
}
